import { createRootRoute, Outlet } from '@tanstack/react-router';
import { SiteHeader } from '../features/shared/components/SiteHeader';
import { Layout } from '../features/shared/components/layout/Layout';
import { PushNotificationModal } from '../features/push-notifications/components/PushNotificationModal';
import { TanStackRouterDevToolsSuspense } from '../setup/dev-tools/TanStackRouterDevtools';

export const Route = createRootRoute({
    component: () => (
        <>
            <Layout>
                <SiteHeader />
                <Outlet />
            </Layout>
            <PushNotificationModal />
            <TanStackRouterDevToolsSuspense />
        </>
    ),
})
